import {createApp} from "vue";
import Redirect from "@/vue/redirects/Redirect.vue";

const redirectApp = createApp(Redirect);
redirectApp.mount('#redirect');